import "../Styles/framework.css";
import { useNavigate } from "react-router-dom";

function Framework() {

const navigate = useNavigate(); 

/* FRAMEWORK CARDS (6) */

const frameworkCards = [
{
icon:"/assets/Guarantee.png",
title:"Leadership, Trust & Integrity",
points:[
"Leadership credibility and ethical conduct",
"Transparency and open communication",
"Accountability and consistency",
"Fair and responsible decision-making",
"Employee confidence in leadership"
]
},
{
icon:"/assets/Manager.png",
title:"Employee Experience, Belonging & Collaboration",
points:[
"Employee engagement and voice",
"Respect, dignity and mutual support",
"Teamwork and cross-functional collaboration",
"Psychological safety and inclusion",
"Recognition, camaraderie and organizational pride"
]
},
{
icon:"/assets/Child_Safe_Zone.png",
title:"Wellbeing, Equity & Fair Opportunity",
points:[
"Physical, mental and financial wellbeing",
"Fair compensation and equitable treatment",
"Diversity, equity and accessibility",
"Work-life balance and flexible work",
"Equal access to recognition and opportunities"
]
},
{
icon:"/assets/Office.png",
title:"Purpose, Meaningful Work & Achievement",
points:[
"Clear organizational purpose and values",
"Meaningful roles and employee contribution",
"Clear goals and performance expectations",
"Achievement, appreciation and recognition",
"Pride in organizational impact and success"
]
},
{
icon:"/assets/Sustainability.png",
title:"Learning, Innovation & Future Readiness",
points:[
"Continuous learning and skill development",
"Career progression and internal mobility",
"Leadership development and succession planning",
"Digital transformation and responsible AI adoption",
"Innovation, agility and continuous improvement"
]
},
{
icon:"/fw_icon.png",   /* NEW card icon */
title:"Workplace Excellence & Sustainable Impact",
points:[
"Effective HR policies and workplace systems",
"Productivity and operational excellence",
"Employee retention and workforce sustainability",
"Social responsibility and environmental stewardship",
"Measurable people outcomes and long-term business impact"
]
}
];

/* BENEFITS (8) */

const benefits = [
{
title:"Credible workplace recognition",
text:"Show stakeholders that your organization assesses its culture and people practices through a structured framework."
},
{
title:"Stronger employee experience",
text:"Understand employee feedback and identify opportunities to improve trust, belonging, fairness and recognition."
},
{
title:"Better-informed leadership decisions",
text:"Translate survey results and workplace evidence into practical priorities for executives and HR teams."
},
{
title:"Employer brand differentiation",
text:"Communicate your workplace commitments using approved certification marks and recognition assets."
},
{
title:"Talent attraction and retention",
text:"Strengthen the conditions that can support engagement, growth and employees' intention to stay."
},
{
title:"Actionable improvement roadmap",
text:"Use findings to prioritize actions, assign ownership and monitor progress over time."
},
{
title:"Future-ready capabilities",
text:"Review learning, leadership development, digital adoption and continuous improvement practices."
},
{
title:"Business-aligned people outcomes",
text:"Connect workplace initiatives with relevant measures such as retention, internal mobility, learning and productivity."
}
];

/* WHY OUTSTANDING WORKPLACES (4) */

const whyCards = [
{
icon:"/assets/Diploma.png",
title:"Credible & Transparent Certification",
text:"Built on a clearly defined assessment framework, transparent scoring methodology, strict employee confidentiality, and independent expert guidance to ensure credibility and trust."
},
{
icon:"/assets/Leadership.png",
title:"Beyond Engagement: A Future-Ready Framework",
text:"Evaluates leadership, employee experience, psychological safety, responsible AI, digital well-being, ESG, and future readiness to recognize workplaces prepared for tomorrow."
},
{
  icon: "/fw_icon_2.png",
  title: "Insights That Drive Real Improvement",
  text: "Combines employee feedback, workplace practices, and relevant people indicators to identify strengths, uncover improvement areas, and deliver actionable recommendations."
},
{
icon:"/fw_icon_process.png",   /* NEW card icon */
title:"Fair, Inclusive & Continuously Evolving",
text:"Designed for organizations of different sizes, sectors, and maturity levels, with proportionate assessment requirements, relevant benchmarking, and annual recertification to encourage sustained progress."
}
];

/* CERTIFICATION PROCESS STEPS */

const steps = [

{
id:"01",
 icon: "/assets/icon_1.png",
title:"Application & Eligibility Check",
points:["Register interest, share company size & industry."]
},

{
id:"02",
icon:"/assets/icon_2.png",
title:"Employee Survey Rollout",
points:["Confidential online survey (2–3 weeks)"]
},

{
id:"03",
icon:"/assets/icon_3.png",
title:"Analysis & Benchmarking",
points:["Compare against industry peers & size-based benchmarks"]
},

{
id:"04",
icon:"/assets/icon_4.png",
title:"Final Scoring & Rating",
points:["Weighted calculation, certification awarded"]
},

{
id:"05",
icon:"/assets/icon_5.png",
title:"Recognition & Branding",
points:[
"Certificate + digital badge valid for 1 year.",
"Featured in Outstanding Workplaces Annual Report.",
"Social Media Campaigns and recognition."
]
}

];

return (
<>

{/* FIRST SECTION */}

<section className="frame">

<div className="frame-left">

<h1 className="frame-title">
Outstanding Workplaces <br/> Certification Framework.
</h1>

<p className="frame-desc">
Outstanding Workplaces Certification recognizes organizations that demonstrate 
excellence in employee experience, culture, and sustainable business practices,
across different industries and sizes.
</p>

<button
            className="frame-btn"
            onClick={() => navigate("/nominate")} // 👈 Navigate when clicked
          >
            <img src="/assets/Badge.png" alt="badge" className="frame-icon" />
            Get Certificate
          </button>

</div>

<div className="frame-right">
<img src="/assets/frame.png" alt="team" />
</div>

</section>


{/* SECOND SECTION */}

<section className="certification-section">

<h2 className="cert-title">
The Certification Aim
</h2>

<div className="cert-content">

<div className="cert-column">

<div className="cert-card">
<ul>
<li>Promote employee well-being, trust, and inclusion.</li>
</ul>
</div>

<div className="cert-card">
<ul>
<li>Provide a benchmark for organizations to compare and improve.</li>
</ul>
</div>

</div>


<div className="cert-timeline">

<div className="cert-timeline-slot">
<div className="cert-circle">✓</div>
</div>

<div className="cert-line"></div>

<div className="cert-timeline-slot">
<div className="cert-circle">✓</div>
</div>

</div>


<div className="cert-column">

<div className="cert-card">
<ul>
<li>Encourage ethical leadership and responsible practices.</li>
</ul>
</div>

<div className="cert-card">
<ul>
<li>Celebrate organizations that create meaningful impact for people, business, and society.</li>
</ul>
</div>

</div>

</div>

</section>


{/* THIRD SECTION */}

<section className="proven-section fw-section">

<h2 className="proven-title">
Introducing Our Proven Framework
</h2>

<p className="proven-subtitle">
What are the Outstanding Workplaces the Framework balances employee perception with organizational practices
</p>

<div className="fw-grid">

{frameworkCards.map((card,index)=>(
<div className="fw-card" key={index}>

<div className="fw-card-icon">
<img src={card.icon} alt="icon" />
</div>

<h3 className="fw-card-title">{card.title}</h3>

<ul className="fw-card-list">
{card.points.map((point,i)=>(
<li key={i}>
<img src="/fw_icon_tick.png" alt="tick" className="fw-tick" />
<span>{point}</span>
</li>
))}
</ul>

</div>
))}

</div>

</section>


{/* FOURTH SECTION */}

<section className="rating-section">

<h2 className="rating-title">
Eligibility Criteria & Rating Scale
</h2>

<div className="rating-wrapper">

<div className="rating-card">
<ul>
<li>Minimum of 2 years of operation</li>
<li>Minimum 10+ employee headcount</li>
<li>Willingness to conduct confidential employee surveys.</li>
<li>Commitment to transparency and data sharing during the assessment, agreement to random audit call/verification.</li>
</ul>
</div>

<div className="rating-card">

<p className="rating-weight">
Overall Weighted Score = (70% Survey + 30% Practices)
</p>

<ul>
<li>90–100% → Exceptional Outstanding Workplaces.</li>
<li>80–89% → Strong Outstanding Workplaces.</li>
<li>70–79% → Certified Outstanding Workplaces.</li>
<li>Below 70% → Not Certified (recommend improvements)</li>
</ul>

</div>

</div>

</section>


{/* BENEFITS */}

<section className="bn-section">

<h2 className="benefits-title">
Key Benefits of Outstanding Workplaces Certification
</h2>

<div className="bn-grid">

{benefits.map((item,index)=>(
<div className="bn-card" key={index}>

<div className="benefit-icon">
<img src="/assets/tick.png" alt="tick" />
</div>

<h3>{item.title}</h3>
<p>{item.text}</p>

</div>
))}

</div>

</section>


{/* WHY OUTSTANDING WORKPLACES */}

<section className="wy-section">

<h2 className="why-title">
Why Outstanding Workplaces?
</h2>

<div className="wy-grid">

{whyCards.map((item,index)=>(
<div className="wy-card" key={index}>

<div className="wy-icon">
<img src={item.icon} alt="icon" />
</div>

<h3>{item.title}</h3>
<p>{item.text}</p>

</div>
))}

</div>

</section>


{/* FIFTH SECTION */}

<section className="process-section">
  <h2 className="process-title">How the Certification Process?</h2>
  <div className="process-row">
    {steps.slice(0, 3).map((step) => (
      <StepCard key={step.id} step={step} />
    ))}
  </div>
  <div className="process-row process-row-center">
    {steps.slice(3).map((step) => (
      <StepCard key={step.id} step={step} />
    ))}
  </div>
</section>

</>
);
}


/* STEP CARD COMPONENT */

const StepCard = ({ step }) => (
  <div className="process-card">
    <div className="process-icon">
      <img src={step.icon} alt={step.title} />
    </div>
    <h3 className="process-card-title">{step.title}</h3>
    <ul className="process-list">
  {step.points.map((point, i) => (
    <li key={i}>
      <span>{point}</span>   {/* 🔥 wrap text */}
    </li>
  ))}
</ul>
  </div>
);

export default Framework;